const lang = {
  page_title: 'シミュレーション新規作成',
  add_raw: '行の追加',
  save: '保存',
  cancel: 'キャンセル',
  defaultInputText: '保存するシミュレーション名',
}

export default lang
